import script from "./SidebarSelectedInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarSelectedInfo.vue?vue&type=script&setup=true&lang=js"

import "./SidebarSelectedInfo.vue?vue&type=style&index=0&id=8ddace02&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ddace02"]])

export default __exports__